// NOTICE: KAPTION-INTEGRATION — Secure Assignment screen (group-visibility.SIMULATOR.1).
// Administrator-only: the screen exists so an admin can understand the configuration
// they are making, and it shows what OTHER people can see.
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/secure-assignment'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'secure_assignment_index',
          // Lazy, like every other settings route — a static import here pulls the
          // screen and its API client into the router module graph at load time.
          component: () => import('./Index.vue'),
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
